import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Checkbox,
  Checklist,
  Field,
  FileField,
  Input,
  Loader
} from '@itds/elements/index.js';

import { Api } from '@brokerage/utils/Api';

const CarrierForm = ({ carrier, loading, onSave }) => {
  const [data, setData] = useState({});
  const [errors, setErrors] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    return () => {
      setData({});
    };
  }, []);

  useEffect(() => {
    setData({
      applicint_id: carrier.applicint_id,
      id: carrier.id,
      insureio_id: carrier.insureio_id,
      is_agency_specific: carrier.is_agency_specific,
      is_forms_default: carrier.is_forms_default,
      is_life_quoting_default: carrier.is_life_quoting_default,
      lifedx_id: carrier.lifedx_id,
      lifedx_token: carrier.lifedx_token,
      logo: carrier.logo,
      name: carrier.name,
      services: carrier.services
    });
  }, [carrier]);

  const handleChange = (name, e) => {
    setData({ ...data, [name]: e.target.value });
  };

  const handleLogoChange = file => {
    setData({ ...data, logo: file });
  };

  const handleCheck = (name, e) => {
    setData({ ...data, [name]: e.target.checked });
  };

  const handleMultiSelect = (name, selected) => {
    setData({ ...data, [name]: selected });
  };

  const handleSave = () => {
    const errors = [];

    if (!data.name) {
      errors.push('name');
    }

    setErrors(errors);

    if (!errors.length) {
      setSaving(true);
      Api.saveCarrier(carrier.id, data)
        .then(() => {
          setSaving(false);
          window.scroll(0, 0);
          onSave('success');
        })
        .catch(() => {
          setSaving(false);
          onSave('error');
        });
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <Field label='Logo'>
        {data.logo && data.logo.url ? (
          <img
            alt='carrier logo'
            src={`${data.logo.url}?${new Date().getTime()}`} // force cache update so new image displays
            style={{ margin: '15px 0', maxWidth: '200px' }}
          />
        ) : null}

        <FileField
          file={data.logo}
          fileUrl={data.logo ? data.logo.url : ''}
          onChange={handleLogoChange}
        />
      </Field>

      <Field label='Name'>
        <Input
          invalid={errors.includes('name')}
          onChange={handleChange.bind(null, 'name')}
          required={true}
          value={data.name || ''}
        />
      </Field>

      <Field label='Services'>
        <Checklist
          onChange={handleMultiSelect.bind(null, 'services')}
          options={[
            { value: 'ltc_quoting', label: 'Long Term Care Quoting' },
            { value: 'life_quoting', label: 'Life Quoting' }
          ]}
          selected={data.services || []}
          style={{ marginBottom: '30px' }}
        />
      </Field>

      <Field label='Insureio ID'>
        <Input
          onChange={handleChange.bind(null, 'insureio_id')}
          type='number'
          value={data.insureio_id || ''}
        />
      </Field>

      <Field label='Applicint ID'>
        <Input onChange={handleChange.bind(null, 'applicint_id')} value={data.applicint_id || ''} />
      </Field>

      <Field label='LifeDX ID'>
        <Input onChange={handleChange.bind(null, 'lifedx_id')} value={data.lifedx_id || ''} />
      </Field>

      <Field label='LifeDX Token'>
        <Input onChange={handleChange.bind(null, 'lifedx_token')} value={data.lifedx_token || ''} />
      </Field>

      <Checkbox
        checked={data.is_agency_specific || null}
        label='This Carrier is specific to one or more agencies'
        onChange={handleCheck.bind(null, 'is_agency_specific')}
      />

      <div style={{ display: 'flex', marginTop: 30 }}>
        <Button
          disabled={saving}
          icon={saving ? 'loading mdi-spin' : null}
          inline={true}
          onClick={handleSave}
        >
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </div>
    </>
  );
};

CarrierForm.propTypes = {
  carrier: PropTypes.object,
  loading: PropTypes.bool,
  onSave: PropTypes.func
};

export default CarrierForm;
